import { api } from '@/utils/apiService';

const specials = {
  namespaced: true,
  state: {
    specialList: [
    ],
  },
  mutations: {
    SET_SPECIALS: (state, dealsList) => {
      state.specialList = Array.isArray(dealsList) ? dealsList : [];
    },
    SET_SPECIAL: (state, deal) => {
      const index = state.specialList.findIndex(item => item.specialID === deal.specialID);
      if (index === -1) {
        state.specialList.push(deal);
      } else {
        state.specialList.splice(index, 1, deal);
      }
    },
    REMOVE_SPECIAL: (state, specialID) => {
      const index = state.specialList.findIndex(
        (item) => Number(item.specialID) === Number(specialID),
      );
      if (index !== -1) {
        state.specialList.splice(index, 1);
      }
    },
    UPDATE_LIVE_COUNTS: (state, payload) => {
      if (!payload || !payload.specials) return;
      state.specialList = state.specialList.map(special => {
        if (payload.specials[special.specialID]) {
          const update = payload.specials[special.specialID];
          return {
            ...special,
            quantityConsumed: update.quantityConsumed ?? special.quantityConsumed,
            quantityRemaining: update.quantityRemaining ?? special.quantityRemaining,
          };
        }
        return special;
      });
    },
  },
  actions: {
    setSpecials: async ({ commit }, specialList) => {
      commit('SET_SPECIALS', specialList);
    },
    // eslint-disable-next-line consistent-return
    requestSpecials: async ({ commit }, params) => {
      try {
        const response = await api.get('/special', { params });
        if (response?.status === 200 && Array.isArray(response.data)) {
          commit('SET_SPECIALS', response.data);
          return response.data;
        }
        commit('SET_SPECIALS', []);
        return [];
      } catch (e) {
        console.log(e);
        commit('SET_SPECIALS', []);
        return [];
      }
    },
    sendSpecial: async ({ dispatch }, params) => {
      try {
        const response = await api.post('/special', params);
        await dispatch('requestSpecials');
        await dispatch('partner/refreshStatus', null, { root: true });
        return response;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    sendSpecialImage: async ({ dispatch }, { params, specialID }) => {
      try {
        const response = await api.post(`/image/special/${specialID}`, params);
        dispatch('requestSpecials');
        return response;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    deleteSpecialImage: async ({ dispatch }, specialID) => {
      try {
        const response = await api.get(`/image/special/delete/${specialID}`);
        dispatch('requestSpecials');
        return response;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    patchSpecial: async ({ dispatch }, params) => {
      const specialID = Number(params?.specialID);
      if (!specialID) {
        throw new Error('special_save_failed');
      }

      const bodyKeys = Object.keys(params || {}).filter((key) => key !== 'specialID');
      const isStatusOnlyToggle = bodyKeys.length === 1 && params.itemStatus !== undefined;

      const response = isStatusOnlyToggle
        ? await api.patch(`/special/${specialID}`, { itemStatus: Number(params.itemStatus) })
        : await api.post('/special', params);

      await dispatch('requestSpecials');
      const httpOk = response?.status === 200 || response?.status === 201;
      const bodyFailed = Number(response?.data?.code) === 422;
      if (!httpOk || bodyFailed) {
        const message = response?.data?.message
          || response?.data?.error
          || response?.statusText
          || 'special_save_failed';
        const error = new Error(message);
        error.response = response;
        throw error;
      }
      await dispatch('partner/refreshStatus', null, { root: true });
      return response;
    },
    cloneSpecial: async ({ dispatch }, { specialID, role }) => {
      const response = await api.post(`/special/${specialID}/clone`, { role });
      const clonedId = Number(response?.data?.specialID);
      const failed = response?.status >= 400 || !clonedId;
      if (failed) {
        const message = response?.data?.message || response?.statusText || 'special_clone_failed';
        const error = new Error(message);
        error.code = response?.data?.error || 'special_clone_failed';
        error.response = response;
        throw error;
      }
      await dispatch('requestSpecials');
      await dispatch('partner/refreshStatus', null, { root: true });
      return { specialID: clonedId };
    },
    setSpecial: async ({ commit }, special) => {
      commit('SET_SPECIAL', special);
    },
    removeSpecial: async ({ commit, dispatch, state }, specialID) => {
      const numericId = Number(specialID);
      const previous = state.specialList.find(
        (item) => Number(item.specialID) === numericId,
      );
      commit('REMOVE_SPECIAL', numericId);
      try {
        const response = await api.delete(`/special/${numericId}`);
        const ok = response?.status === 200
          || response?.status === 202
          || response?.status === 204
          || response?.data?.code === 202;
        if (!ok) {
          throw new Error('special_delete_failed');
        }
        await dispatch('requestSpecials');
        await dispatch('partner/refreshStatus', null, { root: true });
        return response;
      } catch (error) {
        if (previous) {
          commit('SET_SPECIAL', previous);
        }
        throw error;
      }
    },
  },
  getters: {
    getSpecials: (state) => (Array.isArray(state.specialList) ? state.specialList : []),
    getSpecial: state => specialID => state.specialList
      .find(item => item.specialID === Number(specialID)) || {},
  },
};

export default specials;
